
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11800',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11800",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.454",
  "dashboard-client-types": "static-1.293",
  "data-fetching-client": "static-1.9550",
  "foundations-components": "static-1.7664",
  "foundations-components-legacy": "static-1.689",
  "foundations-theming": "static-1.4284",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.79",
  "head-dlb": "static-1.4884",
  "hs-test-utils": "static-1.7884",
  "hub-http-shared-msw-handlers": "static-1.9657",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11317",
  "I18n": "static-7.1598",
  "jasmine-runner": "static-1.6344",
  "marketplace-storefront-base": "static-1.11861",
  "quartz": "static-1.6831",
  "react-dlb": "static-1.74",
  "react-rhumb": "static-1.16526",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2737",
  "reporting-testing-lib": "static-1.8784",
  "settings-ui-lib": "static-1.12397",
  "SharedI18nStrings": "static-1.181",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6886",
  "ui-addon-i18n": "static-1.11020",
  "ui-addon-react-router-dom": "static-1.9419",
  "unified-auth": "static-1.309",
  "unified-auth-core-lib": "static-1.590",
  "usage-tracker": "static-1.7210",
  "usage-tracker-core": "static-1.7060",
  "customer-data-property-utils": "static-1.7956",
  "history": "static-4.47",
  "hub-http": "static-1.6093",
  "integrations-lib": "static-1.15659",
  "marketplace-ui-common": "static-1.19176",
  "property-management-iframe": "static-1.12673",
  "quartz-config": "static-1.609",
  "quartz-core": "static-1.6050",
  "quartz-routing": "static-1.261",
  "quick-fetch": "static-1.3807",
  "react": "static-7.182",
  "rpc-client-utils": "static-1.4518",
  "ts-schema": "static-1.3974",
  "ui-universal-auth": "static-1.8795",
  "UIComponents": "static-3.8264",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.416",
  "hs-promise-rejection-tracking": "static-1.5433",
  "PortalIdParser": "static-2.377",
  "raven": "static-3.5768",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3301",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3108",
  "quartz-webpack": "static-1.3055",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3933",
  "floating-ui": "static-1.53",
  "foundations-assets": "static-1.4714",
  "foundations-theming-specialty": "static-1.2000",
  "framer-motion": "static-1.69",
  "hs-story-utils": "static-1.9301",
  "react-aria": "static-1.63",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5242",
  "react-virtualized": "static-2.96",
  "StyleGuideUI": "static-3.485",
  "tanstack-table": "static-1.52",
  "trellis-assets": "static-1.1429",
  "ui-fonts": "static-1.579",
  "ui-images": "static-2.1124",
  "bend-plugin-foundations-theming": "static-1.2767",
  "foundations-theming-base": "static-1.3269",
  "stylex": "static-1.29",
  "HeadJS": "static-2.732",
  "hs-test-utils-bend-plugin": "static-1.2995",
  "msw": "static-1.39",
  "testing-library": "static-1.149",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.80",
  "jasmine": "static-4.4199",
  "ai-components-ui-library": "static-1.8577",
  "ai-rendering-library": "static-1.9576",
  "chirp-fetch": "static-1.1756",
  "connections-embed-lib": "static-1.740",
  "copilot-toolkit": "static-1.10741",
  "laboratory-lib": "static-3.7034",
  "marketplace-embed": "static-1.21676",
  "marketplace-ui-details": "static-1.9072",
  "marketplace-ui-reviews": "static-1.19132",
  "marketplace-ui-tracking": "static-1.13347",
  "sanitize-text": "static-1.8019",
  "ui-addon-video-player": "static-1.8568",
  "usage-tracker-multi": "static-1.5624",
  "usage-tracker-session-replay": "static-1.4896",
  "wootric-nps": "static-1.6856",
  "apollo-link-hub-http": "static-2.4525",
  "immer": "static-1.33",
  "immerable": "static-1.4027",
  "highcharts": "static-8.101",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2415",
  "reporting-data": "static-1.66851",
  "cssUtils": "static-1.764",
  "flux-actions": "static-1.323",
  "HubStyle": "static-2.11625",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10084",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10248",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7200",
  "icons": "static-2.637",
  "marketplace-ui-apps-core": "static-1.17709",
  "storybook-react": "static-1.30",
  "trellis-story-utils": "static-1.4394",
  "foundations-components-test-utils": "static-1.5147",
  "quartz-i18n": "static-1.506",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3605",
  "customer-data-objects": "static-1.7528",
  "property-translator": "static-1.5282",
  "frontend-preferences-client": "static-1.7798",
  "hs-promise-utils": "static-1.5469",
  "hubspot-apollo-client": "static-1.4753",
  "integrations-error-boundary-lib": "static-1.13074",
  "integrations-tracking-lib": "static-1.5466",
  "native-integrations-shared-strings": "static-1.7660",
  "reselect": "static-2.16",
  "sanitize": "static-1.4348",
  "superstore": "static-1.4642",
  "ui-shepherd-react": "static-3.10020",
  "ai-settings-ui-library": "static-1.7671",
  "hub-http-janus": "static-1.816",
  "hubspotter-http": "static-1.4547",
  "immutable-less": "static-1.4527",
  "marketplace-ui-client-types": "static-1.16583",
  "nav-meta": "static-1.29177",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10116",
  "ui-addon-upgrades": "static-9.17777",
  "inbound-db-properties-service-client": "static-1.3740",
  "property-management-common": "static-1.4961",
  "ui-addon-iframeable": "static-1.8922",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.20",
  "quartz-auth": "static-1.506",
  "quartz-head": "static-1.496",
  "quartz-test": "static-1.506",
  "quartz-tracking": "static-1.210",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.3041",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20656",
  "ContentUtils": "static-1.67860",
  "sassPrefix": "static-1.153",
  "avatar-components": "static-1.2367",
  "customer-data-filters-ui": "static-1.39179",
  "customer-data-objects-ui-components": "static-1.12889",
  "customer-data-reference-ui-components": "static-1.13025",
  "embedded-academy-lib": "static-1.13834",
  "ExportDialog": "static-6.10263",
  "highlight.js": "static-1.76",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40862",
  "reporting-snowflake": "static-1.55469",
  "reporting-ui-components": "static-2.64122",
  "reporting-visualizations": "static-1.58927",
  "ui-addon-teams": "static-1.21354",
  "magpie-lib": "static-1.5468",
  "magpie-types": "static-1.4928",
  "simple-logging-lib": "static-1.2924",
  "navigation-components": "static-1.17540",
  "ai-studio-lib": "static-1.11208",
  "app-governance-lib": "static-1.1114",
  "developer-experience-shared-components": "static-1.10375",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7865",
  "ui-product-approvals": "static-1.27715",
  "ui-tool-access": "static-1.10019",
  "usage-based-billing-components-lib": "static-1.8229",
  "usage-tracker-anonymous": "static-1.5627",
  "usage-tracker-public": "static-1.7021",
  "amplitude-session-replay-browser": "static-1.57",
  "inbound-db-meta-service-client": "static-1.3484",
  "persist-promise": "static-1.3583",
  "reference-resolvers": "static-1.8040",
  "ui-extensibility-client-types": "static-1.3814",
  "hubspot-apollo-cache": "static-1.212",
  "universal-page-editor-lib": "static-1.2876",
  "final-form": "static-1.67",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2389",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4944",
  "purchase-motions-components": "static-1.5615",
  "salesImages": "static-1.522",
  "batch-promise": "static-1.1426",
  "crm-component-utils": "static-1.38677",
  "crm-properties-common-lib": "static-1.5748",
  "customer-data-properties": "static-1.51037",
  "framework-data-schema-resolvers": "static-1.6747",
  "property-value-citations": "static-1.1651",
  "reference-resolvers-lite": "static-1.7961",
  "navigation-messaging": "static-1.6867",
  "hubspotter-http-shared-msw-handlers": "static-1.9655",
  "cms-field-types": "static-1.4682",
  "content-icons-ui": "static-1.2188",
  "conversations-skeleton-state": "static-1.7122",
  "crm-message-bus": "static-1.42594",
  "customer-data-filters-ui-msw-helpers": "static-1.21614",
  "customer-data-ui-utilities": "static-1.9698",
  "FormUrlGenerator": "static-2.4594",
  "framework-builder-read-service-client": "static-1.3902",
  "framework-data-schema-quick-fetch": "static-1.6652",
  "multi-account-reference-resolvers": "static-1.854",
  "onboarding-tours": "static-1.16371",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13276",
  "academy-common-lib": "static-1.13294",
  "content-assistance-lib": "static-1.7555",
  "dashboard-lib": "static-1.80944",
  "file-manager-components": "static-1.23164",
  "getting-started-shared-tasks": "static-1.18093",
  "hubspot-prosemirror": "static-1.17830",
  "hubspot-prosemirror-plugins": "static-1.17822",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19606",
  "share-with-third-party-component-lib": "static-1.8567",
  "ui-addon-draggable": "static-3.4642",
  "ui-asset-management-lib": "static-1.10822",
  "ui-business-units-lib": "static-1.8909",
  "user-context": "static-1.4974",
  "growth-payments-core": "static-1.24941",
  "reporting-plugins": "static-1.10076",
  "reporting-reports": "static-1.66529",
  "idb-keyval": "static-1.41",
  "reactive-lib": "static-1.598",
  "codemirror": "static-5.92",
  "feedback-loader": "static-1.29027",
  "react-codemirror": "static-1.10498",
  "framework-listing-lib": "static-2.28252",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30320",
  "apps-service-types": "static-1.3751",
  "oauth-service-types": "static-1.4121",
  "onboarding-scopes": "static-1.6337",
  "onboarding-tours-client": "static-1.4585",
  "platform-infra-nav-components": "static-1.7561",
  "subscription-experience-data-types": "static-1.14685",
  "crm-record-cards-service-types": "static-1.3511",
  "location-customization-utils-lib": "static-1.8797",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4372",
  "nav-client-types": "static-1.2231",
  "purchase-motions-api": "static-1.5618",
  "signup-constants": "static-1.18569",
  "signup-ui-url-generator": "static-2.7910",
  "trials-service-types": "static-1.3773",
  "card-properties-lib": "static-1.43742",
  "commerce-subscription-lib": "static-1.36676",
  "crm-actions": "static-1.6185",
  "crm-cards-sdk": "static-1.43152",
  "customer-data-properties-shared-msw-handlers": "static-1.8984",
  "customer-data-tracking": "static-1.6757",
  "hs-resources": "static-1.7",
  "pulse": "static-1.405",
  "calling-global-api": "static-1.63965",
  "calling-internal-common": "static-1.31174",
  "calling-lifecycle-internal": "static-1.65347",
  "calling-lifecycle-messages": "static-1.57641",
  "commerce-products-lib": "static-1.9057",
  "conditional-properties-service-client": "static-1.3692",
  "crm-links": "static-1.6145",
  "external-options-client-types": "static-1.4053",
  "google-libphonenumber": "static-1.35",
  "inbounddb-objects-service-types": "static-1.4117",
  "meetings-icalendar-utils-lib": "static-1.505",
  "multi-currency-client-types": "static-1.3584",
  "object-builder-ui-client": "static-1.48267",
  "pipeline-validation-client-types": "static-1.3858",
  "smart-property-lib": "static-1.6254",
  "tiered-pricing": "static-1.953",
  "ui-addon-form-validation": "static-1.10866",
  "crm-pipelines-api-client-types": "static-1.4036",
  "react-dnd-compat": "static-1.4493",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5234",
  "growth-onboarding-confetti": "static-1.2946",
  "growth-onboarding-next-action-utils": "static-1.1500",
  "onboarding-tours-utils": "static-1.437",
  "ui-shepherd-tracker": "static-1.7401",
  "academy-service-client": "static-1.3554",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28147",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8257",
  "video-components-external": "static-1.10810",
  "video-data-lib": "static-1.34468",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8432",
  "payment-link-components": "static-1.23138",
  "ui-addon-emoji-picker": "static-1.9761",
  "EmailSignatureEditor": "static-1.24058",
  "viral-links-lib": "static-1.6914",
  "data-token-picker": "static-1.16177",
  "FileManagerLib": "static-1.38804",
  "react-flip-move": "static-1.67",
  "timezone-utils": "static-2.5118",
  "getting-started-shared-tasks-store": "static-1.17211",
  "campaign-roi-lib": "static-1.8511",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7197",
  "customer-data-views-management": "static-1.25146",
  "framework-data-table": "static-2.11597",
  "marketing-platform-lib": "static-1.6721",
  "nudge-client-utils": "static-1.2303",
  "nudge-custom-ui-functions": "static-1.804",
  "app-users-service-client": "static-1.5420",
  "app-users-service-types": "static-1.4828",
  "mini-checkout-client": "static-1.26498",
  "onboarding-utils": "static-1.5224",
  "permissions-shared-i18n-strings-fe": "static-1.1975",
  "ui-coaching-tips-shared-config": "static-1.28132",
  "edison-service-client-types": "static-1.266",
  "eligibility-engine-service-types": "static-1.3054",
  "crm_data": "static-4.91501",
  "customer-data-sidebar": "static-2.45623",
  "enrichment-properties-lib": "static-1.15372",
  "commerce-billing-lib": "static-1.18699",
  "commerce-shared-components-lib": "static-1.18160",
  "commerce-tools-ui-lib": "static-1.9995",
  "crm-fe-perf": "static-1.22777",
  "directed-graph": "static-1.812",
  "event-emitter": "static-1.821",
  "fast-json-patch": "static-1.60",
  "calling-error-reporting": "static-1.31180",
  "shared-worker-versioning": "static-1.10913",
  "calling-usage-tracker": "static-1.6415",
  "voice-sms-access-library": "static-1.471",
  "commerce-permissions": "static-1.638",
  "products-iframe-lib": "static-1.7543",
  "products-ui-components-shared-msw-handlers": "static-1.10039",
  "breeze-intelligence-kit": "static-1.5428",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9740",
  "policy-lib": "static-1.6653",
  "react-tinymce": "static-1.54841",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9803",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53967",
  "tinymce-plugins": "static-1.57081",
  "tinymce-themes": "static-1.55937",
  "growth-onboarding-next-action-components": "static-1.1528",
  "user-context-client": "static-1.4486",
  "growth-onboarding-feedback-components": "static-1.6455",
  "content-media-composition-data-lib": "static-1.11759",
  "content-media-compositions": "static-2.15766",
  "media-bridge-lib": "static-1.18698",
  "commerce-tours-lib": "static-1.5846",
  "growth-onboarding-reliability": "static-1.4960",
  "sales-checkout-service-client": "static-1.3542",
  "draft-convert": "static-2.70",
  "draft-extend": "static-3.72",
  "draft-js": "static-5.75",
  "draft-plugins": "static-2.21444",
  "sales-email-signature-service-client": "static-1.3717",
  "audio-components": "static-1.5718",
  "FileManagerCore": "static-1.38663",
  "FileManagerImages": "static-1.36315",
  "video-components": "static-1.12813",
  "crm-export-dialog": "static-1.6168",
  "crm-index-associations-lib": "static-1.6310",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1516",
  "tanstack-virtual": "static-1.27",
  "nudge-custom-function-registry": "static-1.2060",
  "nudge-renderer-utils": "static-1.2379",
  "whisper-core-api": "static-1.6199",
  "InboxConnectUtils": "static-4.14426",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5230",
  "settings-content-modals": "static-1.45676",
  "crm_universal": "static-1.21779",
  "customer-data-email": "static-1.17804",
  "card-payment-highlight-lib": "static-1.36729",
  "card-subscription-highlight-lib": "static-1.39099",
  "commerce-contract-lib": "static-1.11477",
  "invoices-highlight-card-lib": "static-1.54267",
  "orders-highlight-card-lib": "static-1.21070",
  "products-highlight-card-lib": "static-1.17341",
  "quotes-highlight-card-lib": "static-1.71458",
  "crm-source-interpretation-lib": "static-1.5206",
  "utility-belt": "static-1.2414",
  "payments-enrollment-embed-lib": "static-1.22225",
  "customer-data-rte": "static-1.32635",
  "cv-backend-services": "static-1.1531",
  "growth-onboarding-empty-states": "static-1.5479",
  "payments-post-enroll-local-storage-lib": "static-1.4986",
  "qrcode-generator": "static-1.66",
  "quotes-client-types": "static-1.37548",
  "calling-orchestration-schema": "static-1.35248",
  "sales-views-client-types": "static-1.4137",
  "hub-http-contrib": "static-1.2917",
  "interframe": "static-3.4636",
  "tinymce-data": "static-1.40052",
  "ui-addon-sales-email": "static-1.5086",
  "layout-dnd-components": "static-1.12192",
  "layout-dnd-utils": "static-1.11167",
  "ui-brand-identity-lib": "static-1.14440",
  "NamespacedHubStyle": "static-2.8963",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4406",
  "video-embed": "static-1.35302",
  "social-insights-client-types": "static-1.21636",
  "deal-intel-utils": "static-1.1520",
  "checkout-sdk": "static-3.23341",
  "checkout-service-types": "static-1.3720",
  "company-details-components": "static-1.6060",
  "payment-method-components": "static-1.6768",
  "pricing-pages-ui-components": "static-1.13045",
  "quote-checkout-service-types": "static-1.3357",
  "upgrade-catalog-service-types": "static-1.3400",
  "access-control-lib": "static-1.10311",
  "EmailComponents": "static-1.54354",
  "EmailData": "static-1.53031",
  "redux-less": "static-2.9359",
  "sequences-lib": "static-1.7817",
  "ui-gdpr-components": "static-1.10222",
  "products-ui-components": "static-1.39576",
  "quotes-ui-lib": "static-1.80179",
  "accounting-integrations-ui-components": "static-1.6855",
  "invoices-ui-lib": "static-1.54283",
  "commerce-products-api": "static-1.2079",
  "invoices-iframe-lib": "static-1.56341",
  "quotes-modal-lib": "static-1.102136",
  "stripe-embedded-components": "static-1.7274",
  "draft-content-plugins": "static-1.27903",
  "ContentData": "static-1.67935",
  "layout-data-lib": "static-1.9492",
  "outpost": "static-1.4072",
  "hub-http-rxjs": "static-1.782",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3803",
  "billing-payments-client-types": "static-1.3862",
  "account-and-billing-fintech-outages": "static-3.18339",
  "pricing-pages-api": "static-1.12910",
  "ContentComponents": "static-2.70816",
  "marketing-contacts-lib": "static-1.9383",
  "marketing-email-service-types": "static-1.1823",
  "messaging-editing-lib": "static-1.45838",
  "messaging-usage-based-billing-components-lib": "static-1.700",
  "automation-ui-source-apps": "static-1.18446",
  "automation-ui-types": "static-1.19364",
  "messaging-types-lib": "static-1.45575",
  "onboarding-settings-client": "static-1.4378",
  "sequences-client-types-lib": "static-1.7674",
  "commerce-tax-lib": "static-1.391",
  "property-description-translator": "static-1.3728",
  "SalesContentIndexUI": "static-3.9024",
  "commerce-analytics-service-client": "static-1.3530",
  "totals-ui-components": "static-1.23192",
  "stripe-connect-js": "static-1.66",
  "advanced-menus-core": "static-1.14925",
  "advanced-menus-lib": "static-1.11891",
  "ui-memberships-settings-lib": "static-1.33655",
  "demographics-service-types": "static-1.1522",
  "automation-ui-ubb": "static-1.5280",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7214",
  "data-token-views": "static-1.16158",
  "forms-utils-lib": "static-1.12323",
  "payments-embed-points-lib": "static-1.12761",
  "simple-menus-core": "static-1.14924",
  "simple-menus-lib": "static-1.16441",
  "ui-addon-draggable-compat": "static-2.4128",
  "videoconference-integration-components": "static-1.6635",
  "automation-applications-service-types": "static-1.3399",
  "automation-platform-service-types": "static-1.2544",
  "ContentEditorUI": "static-2.76738",
  "short-messages-app-service-client": "static-1.3867",
  "web-interactives-components": "static-1.13535",
  "web-interactives-data": "static-1.13536",
  "messaging-shared-utils-lib": "static-1.149",
  "messaging-user-info-utils-lib": "static-1.319",
  "email-portal-health-service-types": "static-1.850",
  "FireAlarmUi": "static-1.4403",
  "sales-templates-service-types-lib": "static-1.4061",
  "commerce-totals-service-types": "static-1.3710",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21300",
  "automation-ui-usage-tracking": "static-1.20763",
  "data-studio-ubb": "static-1.2320",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26626",
  "collaboration-sidebar": "static-1.57344",
  "content-management-data-lib": "static-1.5217",
  "copilot-plugins": "static-1.10714",
  "cta-picker": "static-1.36035",
  "customer-agent-discovery-components-lib": "static-1.2652",
  "editor-components": "static-1.13041",
  "editor-iframe-lib": "static-1.8221",
  "error-messaging-js": "static-1.5064",
  "FormsCommonComponents": "static-1.85480",
  "pictos": "static-7.181",
  "react-transition-group": "static-2.62",
  "redux-request-state": "static-1.10519",
  "SharedLegalStrings": "static-1.1626",
  "smart-content-core": "static-1.42060",
  "smart-content-lib": "static-1.42713",
  "social-composer-lib": "static-1.58438",
  "structured-content-lib": "static-1.24817",
  "theme-previewer-lib": "static-1.52889",
  "tinymce-copilot": "static-1.16035",
  "xray-recommendation-lib": "static-1.7702",
  "automation-ui-routing": "static-1.20721",
  "sql-reporting-client-types": "static-1.5538",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.41843",
  "campaigns-utils-lib": "static-1.3029",
  "reporting-enablement": "static-1.22361",
  "chatspot-widget-iframe": "static-1.20648",
  "collaboration-sidebar-common": "static-1.2141",
  "forms-ai-lib": "static-1.4115",
  "codemirror-dlb": "static-1.58297",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6302",
  "report-customization-components": "static-1.12738",
  "data-quality-ui-library": "static-1.12520",
  "html-to-image": "static-1.51",
  "reporting-insights-lib": "static-1.1292"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11800",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.454",
  "dashboard-client-types": "/dashboard-client-types/static-1.293",
  "data-fetching-client": "/data-fetching-client/static-1.9550",
  "foundations-components": "/foundations-components/static-1.7664",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.689",
  "foundations-theming": "/foundations-theming/static-1.4284",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.79",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-test-utils": "/hs-test-utils/static-1.7884",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9657",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11317",
  "I18n": "/I18n/static-7.1598",
  "jasmine-runner": "/jasmine-runner/static-1.6344",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11861",
  "quartz": "/quartz/static-1.6831",
  "react-dlb": "/react-dlb/static-1.74",
  "react-rhumb": "/react-rhumb/static-1.16526",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2737",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8784",
  "settings-ui-lib": "/settings-ui-lib/static-1.12397",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6886",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11020",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9419",
  "unified-auth": "/unified-auth/static-1.309",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.590",
  "usage-tracker": "/usage-tracker/static-1.7210",
  "usage-tracker-core": "/usage-tracker-core/static-1.7060",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7956",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6093",
  "integrations-lib": "/integrations-lib/static-1.15659",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19176",
  "property-management-iframe": "/property-management-iframe/static-1.12673",
  "quartz-config": "/quartz-config/static-1.609",
  "quartz-core": "/quartz-core/static-1.6050",
  "quartz-routing": "/quartz-routing/static-1.261",
  "quick-fetch": "/quick-fetch/static-1.3807",
  "react": "/react/static-7.182",
  "rpc-client-utils": "/rpc-client-utils/static-1.4518",
  "ts-schema": "/ts-schema/static-1.3974",
  "ui-universal-auth": "/ui-universal-auth/static-1.8795",
  "UIComponents": "/UIComponents/static-3.8264",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.416",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "raven": "/raven/static-3.5768",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3301",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3108",
  "quartz-webpack": "/quartz-webpack/static-1.3055",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3933",
  "floating-ui": "/floating-ui/static-1.53",
  "foundations-assets": "/foundations-assets/static-1.4714",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2000",
  "framer-motion": "/framer-motion/static-1.69",
  "hs-story-utils": "/hs-story-utils/static-1.9301",
  "react-aria": "/react-aria/static-1.63",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5242",
  "react-virtualized": "/react-virtualized/static-2.96",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tanstack-table": "/tanstack-table/static-1.52",
  "trellis-assets": "/trellis-assets/static-1.1429",
  "ui-fonts": "/ui-fonts/static-1.579",
  "ui-images": "/ui-images/static-2.1124",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2767",
  "foundations-theming-base": "/foundations-theming-base/static-1.3269",
  "stylex": "/stylex/static-1.29",
  "HeadJS": "/HeadJS/static-2.732",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2995",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.149",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.80",
  "jasmine": "/jasmine/static-4.4199",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8577",
  "ai-rendering-library": "/ai-rendering-library/static-1.9576",
  "chirp-fetch": "/chirp-fetch/static-1.1756",
  "connections-embed-lib": "/connections-embed-lib/static-1.740",
  "copilot-toolkit": "/copilot-toolkit/static-1.10741",
  "laboratory-lib": "/laboratory-lib/static-3.7034",
  "marketplace-embed": "/marketplace-embed/static-1.21676",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9072",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19132",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13347",
  "sanitize-text": "/sanitize-text/static-1.8019",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8568",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5624",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4896",
  "wootric-nps": "/wootric-nps/static-1.6856",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4525",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4027",
  "highcharts": "/highcharts/static-8.101",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2415",
  "reporting-data": "/reporting-data/static-1.66851",
  "cssUtils": "/cssUtils/static-1.764",
  "flux-actions": "/flux-actions/static-1.323",
  "HubStyle": "/HubStyle/static-2.11625",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10084",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10248",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7200",
  "icons": "/icons/static-2.637",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17709",
  "storybook-react": "/storybook-react/static-1.30",
  "trellis-story-utils": "/trellis-story-utils/static-1.4394",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5147",
  "quartz-i18n": "/quartz-i18n/static-1.506",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3605",
  "customer-data-objects": "/customer-data-objects/static-1.7528",
  "property-translator": "/property-translator/static-1.5282",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7798",
  "hs-promise-utils": "/hs-promise-utils/static-1.5469",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4753",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13074",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5466",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7660",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4348",
  "superstore": "/superstore/static-1.4642",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10020",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7671",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "hubspotter-http": "/hubspotter-http/static-1.4547",
  "immutable-less": "/immutable-less/static-1.4527",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16583",
  "nav-meta": "/nav-meta/static-1.29177",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10116",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17777",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3740",
  "property-management-common": "/property-management-common/static-1.4961",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8922",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.20",
  "quartz-auth": "/quartz-auth/static-1.506",
  "quartz-head": "/quartz-head/static-1.496",
  "quartz-test": "/quartz-test/static-1.506",
  "quartz-tracking": "/quartz-tracking/static-1.210",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.3041",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20656",
  "ContentUtils": "/ContentUtils/static-1.67860",
  "sassPrefix": "/sassPrefix/static-1.153",
  "avatar-components": "/avatar-components/static-1.2367",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39179",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12889",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13025",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13834",
  "ExportDialog": "/ExportDialog/static-6.10263",
  "highlight.js": "/highlight.js/static-1.76",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40862",
  "reporting-snowflake": "/reporting-snowflake/static-1.55469",
  "reporting-ui-components": "/reporting-ui-components/static-2.64122",
  "reporting-visualizations": "/reporting-visualizations/static-1.58927",
  "ui-addon-teams": "/ui-addon-teams/static-1.21354",
  "magpie-lib": "/magpie-lib/static-1.5468",
  "magpie-types": "/magpie-types/static-1.4928",
  "simple-logging-lib": "/simple-logging-lib/static-1.2924",
  "navigation-components": "/navigation-components/static-1.17540",
  "ai-studio-lib": "/ai-studio-lib/static-1.11208",
  "app-governance-lib": "/app-governance-lib/static-1.1114",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10375",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7865",
  "ui-product-approvals": "/ui-product-approvals/static-1.27715",
  "ui-tool-access": "/ui-tool-access/static-1.10019",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8229",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5627",
  "usage-tracker-public": "/usage-tracker-public/static-1.7021",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.57",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3484",
  "persist-promise": "/persist-promise/static-1.3583",
  "reference-resolvers": "/reference-resolvers/static-1.8040",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3814",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.212",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2876",
  "final-form": "/final-form/static-1.67",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2389",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4944",
  "purchase-motions-components": "/purchase-motions-components/static-1.5615",
  "salesImages": "/salesImages/static-1.522",
  "batch-promise": "/batch-promise/static-1.1426",
  "crm-component-utils": "/crm-component-utils/static-1.38677",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5748",
  "customer-data-properties": "/customer-data-properties/static-1.51037",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6747",
  "property-value-citations": "/property-value-citations/static-1.1651",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7961",
  "navigation-messaging": "/navigation-messaging/static-1.6867",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9655",
  "cms-field-types": "/cms-field-types/static-1.4682",
  "content-icons-ui": "/content-icons-ui/static-1.2188",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7122",
  "crm-message-bus": "/crm-message-bus/static-1.42594",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21614",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9698",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4594",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3902",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6652",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.854",
  "onboarding-tours": "/onboarding-tours/static-1.16371",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13276",
  "academy-common-lib": "/academy-common-lib/static-1.13294",
  "content-assistance-lib": "/content-assistance-lib/static-1.7555",
  "dashboard-lib": "/dashboard-lib/static-1.80944",
  "file-manager-components": "/file-manager-components/static-1.23164",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18093",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17830",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17822",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19606",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8567",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4642",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10822",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8909",
  "user-context": "/user-context/static-1.4974",
  "growth-payments-core": "/growth-payments-core/static-1.24941",
  "reporting-plugins": "/reporting-plugins/static-1.10076",
  "reporting-reports": "/reporting-reports/static-1.66529",
  "idb-keyval": "/idb-keyval/static-1.41",
  "reactive-lib": "/reactive-lib/static-1.598",
  "codemirror": "/codemirror/static-5.92",
  "feedback-loader": "/feedback-loader/static-1.29027",
  "react-codemirror": "/react-codemirror/static-1.10498",
  "framework-listing-lib": "/framework-listing-lib/static-2.28252",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30320",
  "apps-service-types": "/apps-service-types/static-1.3751",
  "oauth-service-types": "/oauth-service-types/static-1.4121",
  "onboarding-scopes": "/onboarding-scopes/static-1.6337",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4585",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7561",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14685",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3511",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8797",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4372",
  "nav-client-types": "/nav-client-types/static-1.2231",
  "purchase-motions-api": "/purchase-motions-api/static-1.5618",
  "signup-constants": "/signup-constants/static-1.18569",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7910",
  "trials-service-types": "/trials-service-types/static-1.3773",
  "card-properties-lib": "/card-properties-lib/static-1.43742",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36676",
  "crm-actions": "/crm-actions/static-1.6185",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43152",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8984",
  "customer-data-tracking": "/customer-data-tracking/static-1.6757",
  "hs-resources": "/hs-resources/static-1.7",
  "pulse": "/pulse/static-1.405",
  "calling-global-api": "/calling-global-api/static-1.63965",
  "calling-internal-common": "/calling-internal-common/static-1.31174",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65347",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57641",
  "commerce-products-lib": "/commerce-products-lib/static-1.9057",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3692",
  "crm-links": "/crm-links/static-1.6145",
  "external-options-client-types": "/external-options-client-types/static-1.4053",
  "google-libphonenumber": "/google-libphonenumber/static-1.35",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4117",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.505",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3584",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48267",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3858",
  "smart-property-lib": "/smart-property-lib/static-1.6254",
  "tiered-pricing": "/tiered-pricing/static-1.953",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10866",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4036",
  "react-dnd-compat": "/react-dnd-compat/static-1.4493",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5234",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2946",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1500",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.437",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7401",
  "academy-service-client": "/academy-service-client/static-1.3554",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28147",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8257",
  "video-components-external": "/video-components-external/static-1.10810",
  "video-data-lib": "/video-data-lib/static-1.34468",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8432",
  "payment-link-components": "/payment-link-components/static-1.23138",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9761",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24058",
  "viral-links-lib": "/viral-links-lib/static-1.6914",
  "data-token-picker": "/data-token-picker/static-1.16177",
  "FileManagerLib": "/FileManagerLib/static-1.38804",
  "react-flip-move": "/react-flip-move/static-1.67",
  "timezone-utils": "/timezone-utils/static-2.5118",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17211",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8511",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7197",
  "customer-data-views-management": "/customer-data-views-management/static-1.25146",
  "framework-data-table": "/framework-data-table/static-2.11597",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6721",
  "nudge-client-utils": "/nudge-client-utils/static-1.2303",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.804",
  "app-users-service-client": "/app-users-service-client/static-1.5420",
  "app-users-service-types": "/app-users-service-types/static-1.4828",
  "mini-checkout-client": "/mini-checkout-client/static-1.26498",
  "onboarding-utils": "/onboarding-utils/static-1.5224",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.1975",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28132",
  "edison-service-client-types": "/edison-service-client-types/static-1.266",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3054",
  "crm_data": "/crm_data/static-4.91501",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45623",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15372",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18699",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18160",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9995",
  "crm-fe-perf": "/crm-fe-perf/static-1.22777",
  "directed-graph": "/directed-graph/static-1.812",
  "event-emitter": "/event-emitter/static-1.821",
  "fast-json-patch": "/fast-json-patch/static-1.60",
  "calling-error-reporting": "/calling-error-reporting/static-1.31180",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10913",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6415",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.471",
  "commerce-permissions": "/commerce-permissions/static-1.638",
  "products-iframe-lib": "/products-iframe-lib/static-1.7543",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10039",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5428",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9740",
  "policy-lib": "/policy-lib/static-1.6653",
  "react-tinymce": "/react-tinymce/static-1.54841",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9803",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53967",
  "tinymce-plugins": "/tinymce-plugins/static-1.57081",
  "tinymce-themes": "/tinymce-themes/static-1.55937",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1528",
  "user-context-client": "/user-context-client/static-1.4486",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6455",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11759",
  "content-media-compositions": "/content-media-compositions/static-2.15766",
  "media-bridge-lib": "/media-bridge-lib/static-1.18698",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5846",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4960",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3542",
  "draft-convert": "/draft-convert/static-2.70",
  "draft-extend": "/draft-extend/static-3.72",
  "draft-js": "/draft-js/static-5.75",
  "draft-plugins": "/draft-plugins/static-2.21444",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3717",
  "audio-components": "/audio-components/static-1.5718",
  "FileManagerCore": "/FileManagerCore/static-1.38663",
  "FileManagerImages": "/FileManagerImages/static-1.36315",
  "video-components": "/video-components/static-1.12813",
  "crm-export-dialog": "/crm-export-dialog/static-1.6168",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6310",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1516",
  "tanstack-virtual": "/tanstack-virtual/static-1.27",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2060",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2379",
  "whisper-core-api": "/whisper-core-api/static-1.6199",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14426",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5230",
  "settings-content-modals": "/settings-content-modals/static-1.45676",
  "crm_universal": "/crm_universal/static-1.21779",
  "customer-data-email": "/customer-data-email/static-1.17804",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36729",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39099",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11477",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54267",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21070",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17341",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71458",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5206",
  "utility-belt": "/utility-belt/static-1.2414",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22225",
  "customer-data-rte": "/customer-data-rte/static-1.32635",
  "cv-backend-services": "/cv-backend-services/static-1.1531",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5479",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4986",
  "qrcode-generator": "/qrcode-generator/static-1.66",
  "quotes-client-types": "/quotes-client-types/static-1.37548",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35248",
  "sales-views-client-types": "/sales-views-client-types/static-1.4137",
  "hub-http-contrib": "/hub-http-contrib/static-1.2917",
  "interframe": "/interframe/static-3.4636",
  "tinymce-data": "/tinymce-data/static-1.40052",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5086",
  "layout-dnd-components": "/layout-dnd-components/static-1.12192",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11167",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14440",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8963",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4406",
  "video-embed": "/video-embed/static-1.35302",
  "social-insights-client-types": "/social-insights-client-types/static-1.21636",
  "deal-intel-utils": "/deal-intel-utils/static-1.1520",
  "checkout-sdk": "/checkout-sdk/static-3.23341",
  "checkout-service-types": "/checkout-service-types/static-1.3720",
  "company-details-components": "/company-details-components/static-1.6060",
  "payment-method-components": "/payment-method-components/static-1.6768",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.13045",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3357",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3400",
  "access-control-lib": "/access-control-lib/static-1.10311",
  "EmailComponents": "/EmailComponents/static-1.54354",
  "EmailData": "/EmailData/static-1.53031",
  "redux-less": "/redux-less/static-2.9359",
  "sequences-lib": "/sequences-lib/static-1.7817",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10222",
  "products-ui-components": "/products-ui-components/static-1.39576",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80179",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6855",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54283",
  "commerce-products-api": "/commerce-products-api/static-1.2079",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56341",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102136",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7274",
  "draft-content-plugins": "/draft-content-plugins/static-1.27903",
  "ContentData": "/ContentData/static-1.67935",
  "layout-data-lib": "/layout-data-lib/static-1.9492",
  "outpost": "/outpost/static-1.4072",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.782",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3803",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3862",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18339",
  "pricing-pages-api": "/pricing-pages-api/static-1.12910",
  "ContentComponents": "/ContentComponents/static-2.70816",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9383",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1823",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.45838",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.700",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18446",
  "automation-ui-types": "/automation-ui-types/static-1.19364",
  "messaging-types-lib": "/messaging-types-lib/static-1.45575",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4378",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7674",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.391",
  "property-description-translator": "/property-description-translator/static-1.3728",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9024",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3530",
  "totals-ui-components": "/totals-ui-components/static-1.23192",
  "stripe-connect-js": "/stripe-connect-js/static-1.66",
  "advanced-menus-core": "/advanced-menus-core/static-1.14925",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11891",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33655",
  "demographics-service-types": "/demographics-service-types/static-1.1522",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5280",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7214",
  "data-token-views": "/data-token-views/static-1.16158",
  "forms-utils-lib": "/forms-utils-lib/static-1.12323",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12761",
  "simple-menus-core": "/simple-menus-core/static-1.14924",
  "simple-menus-lib": "/simple-menus-lib/static-1.16441",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4128",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6635",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3399",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2544",
  "ContentEditorUI": "/ContentEditorUI/static-2.76738",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3867",
  "web-interactives-components": "/web-interactives-components/static-1.13535",
  "web-interactives-data": "/web-interactives-data/static-1.13536",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.149",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.319",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.850",
  "FireAlarmUi": "/FireAlarmUi/static-1.4403",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4061",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3710",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21300",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.20763",
  "data-studio-ubb": "/data-studio-ubb/static-1.2320",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26626",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57344",
  "content-management-data-lib": "/content-management-data-lib/static-1.5217",
  "copilot-plugins": "/copilot-plugins/static-1.10714",
  "cta-picker": "/cta-picker/static-1.36035",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2652",
  "editor-components": "/editor-components/static-1.13041",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8221",
  "error-messaging-js": "/error-messaging-js/static-1.5064",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85480",
  "pictos": "/pictos/static-7.181",
  "react-transition-group": "/react-transition-group/static-2.62",
  "redux-request-state": "/redux-request-state/static-1.10519",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1626",
  "smart-content-core": "/smart-content-core/static-1.42060",
  "smart-content-lib": "/smart-content-lib/static-1.42713",
  "social-composer-lib": "/social-composer-lib/static-1.58438",
  "structured-content-lib": "/structured-content-lib/static-1.24817",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.52889",
  "tinymce-copilot": "/tinymce-copilot/static-1.16035",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7702",
  "automation-ui-routing": "/automation-ui-routing/static-1.20721",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5538",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.41843",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3029",
  "reporting-enablement": "/reporting-enablement/static-1.22361",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20648",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2141",
  "forms-ai-lib": "/forms-ai-lib/static-1.4115",
  "codemirror-dlb": "/codemirror-dlb/static-1.58297",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6302",
  "report-customization-components": "/report-customization-components/static-1.12738",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12520",
  "html-to-image": "/html-to-image/static-1.51",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1292"
}
};
